var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.HlsJsAds = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-hlsTag-ads'
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.media.currentTime - this.initialPlayhead
  },

  getTitle: function () {
    return this.metadata.ADID
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.metadata.formattedDuration || this.duration
  },

  getCreativeId: function () {
    return this.metadata.CreativeID
  },

  getResource: function () {
    return this.metadata.resource
  },

  getPosition: function () {
    var adapter = this.plugin.getAdapter()
    var ret = youbora.Constants.AdPosition.Midroll
    if (adapter && !adapter.getIsLive()) {
      if (adapter.getPlayhead() < 1) {
        ret = youbora.Constants.AdPosition.Preroll
      } else if (adapter.getPlayhead() + 1 > adapter.getDuration()) {
        ret = youbora.Constants.AdPosition.Postroll
      }
    }
    return ret
  },

  getIsFullscreen: function () {
    var ret = false
    for (var index in this.tag) {
      if (this.tag[index] && this.tag[index].width && this.tag[index].height) {
        if (window.innerHeight && window.innerWidth && this.tag[index].width && this.tag[index].height) {
          ret = (window.innerHeight <= this.tag[index].height + 30 && window.innerWidth <= this.tag[index].width + 30)
        }
      }
    }
    return ret
  },

  getIsVisible: function () {
    return youbora.Util.calculateAdViewability(this.tag)
  },

  getAudioEnabled: function () {
    var ret = !this.tag.muted
    if (ret) {
      ret = this.tag.volume > 0
    }
    return ret
  },

  getIsSkippable: function () {
    return false
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    this.monitorPlayhead(true, false)
    this.references = {
      hlsFragParsingMetadata: this.metadataListener.bind(this),
      hlsFragChanged: this.changedListener.bind(this),
      hlsMediaAttached: this.getTagListener.bind(this)
    }
    this.tagReferences = {
      pause: this.pauseListener.bind(this),
      playing: this.playingListener.bind(this)
    }
    if (this.player) {
      for (var key in this.references) {
        this.player.on(key, this.references[key])
      }
    }
    this.metadata = {}
    this.getTagListener()
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()
    if (this.player) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
    }
    if (this.tag) {
      for (var key2 in this.tagReferences) {
        this.tag.removeEventListener(key2, this.tagReferences[key2])
      }
    }
  },

  changedListener: function (e, m) {
    var url = m.frag.relurl
    var subUrl = url.substr(0, url.lastIndexOf('/'))
    for (var tag in m.frag.tagList) {
      var firstTag = m.frag.tagList[tag][0]
      if (firstTag === 'EXT-X-CUE-OUT') {
        this.startedByTag = true
        this.duration = m.frag.tagList[tag][1]
        this._start(m)
      } else if (firstTag === 'EXT-X-ADSTART') {
        if (this.flags.isJoined) {
          this._stop()
        }
        var json = '{"' + m.frag.tagList[tag][1].replace(/=/g, '":"').replace(/,/g, '","') + '"}'
        this.metadata = JSON.parse(json)
        this.metadata.resource = url
        if (this.metadata.Duration) {
          var a = this.metadata.Duration.split(':')
          var hour = parseInt(a[0])
          var min = parseInt(a[1])
          var sec = parseInt(a[2])
          this.metadata.formattedDuration = (((hour * 60) + min) * 60) + sec
        }
        this._start()
        this.fireJoin()
      } else if (firstTag === 'EXT-X-CUE-IN') {
        this.startedByTag = false
        this._stop()
        this.fireBreakStop()
      } else if (!this.startedByTag) {
        if ((this.adUrl && subUrl === this.adUrl)) {
          this._start()
        } else if (this.flags.isStarted) {
          this._stop()
          this.fireBreakStop()
        }
      }
    }
  },

  _start: function () {
    if (!this.flags.isStarted) {
      this.initialPlayhead = this.player.media.currentTime
      this.fireStart()
    }
  },

  _stop: function () {
    this.adUrl = null
    this.fireStop()
    this.metadata = {}
    this.duration = null
  },

  metadataListener: function (e, m) {
    var url = m.frag.relurl
    this.adUrl = url.substr(0, url.lastIndexOf('/'))
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
  },

  getTagListener: function () {
    this.tag = this.player ? this.player.media : null
    if (this.tag) {
      for (var key in this.tagReferences) {
        this.tag.addEventListener(key, this.tagReferences[key])
      }
    }
  }
})

module.exports = youbora.adapters.HlsJsAds
